/**
 * Beep corto para la notificación de incidencias nuevas del dashboard
 * (HU-012) — generado con Web Audio API en vez de cargar un archivo .mp3,
 * no hace falta agregar ningún asset nuevo al proyecto para un sonido tan
 * simple. Si el navegador bloquea el audio (autoplay, sin interacción
 * previa del usuario) falla en silencio — el widget visual sigue
 * funcionando igual, el sonido es un extra, no algo crítico.
 */
export const reproducirSonidoAlerta = () => {
  try {
    const Contexto = window.AudioContext || window.webkitAudioContext;
    const ctx = new Contexto();
    const oscilador = ctx.createOscillator();
    const ganancia = ctx.createGain();
    oscilador.type = 'sine';
    oscilador.frequency.value = 880;
    ganancia.gain.setValueAtTime(0.15, ctx.currentTime);
    ganancia.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
    oscilador.connect(ganancia).connect(ctx.destination);
    oscilador.start();
    oscilador.stop(ctx.currentTime + 0.4);
  } catch {
    // Web Audio no disponible/bloqueado — sin sonido, sin romper nada más.
  }
};
